import MobileDrawer from '@c/drawers/MobileDrawer';
import ChatDetailsContent from './ChatDetailsContent';
import type { ChatDocument } from 'models/chat';
import type { PublicUserDocument, UserDocument } from 'models/user';
import ProductViewerModal from '@c/modals/ProductViewerModal';
import { useState } from 'react';

export type MobileChatDetailsModalProps = {
  show: boolean;
  dismiss: () => void;
  images?: string[];
  chat: ChatDocument;
  userDoc: UserDocument | null | undefined;
  onArchiveSuccess?: () => void;
  sellerDoc: PublicUserDocument | null | undefined;
  buyerDoc: PublicUserDocument | null | undefined;
};

export default function MobileChatDetailsModal({
  show,
  dismiss,
  images = [],
  chat,
  userDoc,
  onArchiveSuccess,
  sellerDoc,
  buyerDoc,
}: MobileChatDetailsModalProps) {
  const [view, setView] = useState<'details' | 'gallery'>('details');
  const [imageModal, setImageModal] = useState<{
    isOpen: boolean;
    index: number;
    images: { full: string; thumb: string; download_url?: string }[];
  }>({ isOpen: false, index: 0, images: [] });

  const onImageClick = (src: string) => {
    const index = images.findIndex((imageUrl) => imageUrl === src);
    const modalImages = images.map((imageUrl) => ({
      full: imageUrl,
      thumb: imageUrl,
      download_url: imageUrl,
    }));
    setImageModal({
      images: modalImages,
      index: index >= 0 ? index : 0,
      isOpen: true,
    });
  };
  return (
    <>
      <MobileDrawer show={show} dismiss={dismiss} hideCloseButton>
        <div className="overflow-y-auto py-12">
          <ChatDetailsContent
            images={images}
            chat={chat}
            userDoc={userDoc}
            onArchiveSuccess={onArchiveSuccess}
            onDismiss={dismiss}
            view={view}
            setView={setView}
            onImageClick={onImageClick}
            sellerDoc={sellerDoc}
            buyerDoc={buyerDoc}
          />
        </div>
      </MobileDrawer>

      {imageModal.isOpen && (
        <ProductViewerModal
          isOpen={imageModal.isOpen}
          dismiss={() => setImageModal({ ...imageModal, isOpen: false })}
          images={imageModal.images}
          initialImage={imageModal.index}
        />
      )}
    </>
  );
}
